"use client";
import { Link } from "@mui/material";
import { styled } from "@mui/material/styles";
const CustomStylesLink = styled(Link, {
  shouldForwardProp: () => true
})(({ underline }) => ({
  "& .MuiTypography-root:hover, &.Mui-focusVisible .MuiTypography-root": underline === "hover" ? { textDecoration: "underline" } : {}
}));
export {
  CustomStylesLink
};
